// extracted by mini-css-extract-plugin
export default {"banner":"DashboardBanner_banner__96h9a"};